<template>
  <div v-if="1" class="bannerHeader">
    <div
      :class="{
        titleBanner: $store.getters.siteConfig.app_name_short == 'DPC',
        'titleBanner-ag': $store.getters.siteConfig.app_name_short != 'DPC',
      }"
    >
      <span>Uma Seleção de ofertas pensada em você!</span>
      <h3>
        Ganhe <span>descontos exclusivos</span> comprando produtos selecionados.
      </h3>
    </div>
    <img
      v-if="$store.getters.siteConfig.app_name_short == 'DPC'"
      class="imgBanner"
      src="@/assets/img/campanhas/img-banner-principal.svg"
    />
    <img
      class="imgBanner"
      src="@/assets/img/campanhas/img-banner-principal-aglets.svg"
    />
  </div>
  <div v-else>
    <img
      style="width: 100%; border-radius: 6px; margin-bottom: 15px"
      :src="srcImage"
    />
  </div>
</template>

<script>
export default {
  name: "BannerPrincipalCampanha",
  props: {
    paramsCampanha: {
      type: Object,
    },
  },
  data() {
    return {
      srcImage: "",
    };
  },
  computed: {
    campanhaStatus() {
      return this.$store.getters.campanhaStatus;
    },
  },

  watch: {
    campanhaStatus(newValue) {
      this.getDataTimeline();
    },
  },

  created() {
    this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
  },
  methods: {
    getDataTimeline() {
      const campanhaId = this.$route.query.campanhaId;

      if (!this.campanhaStatus[campanhaId]) return;

      const campanhaStatus = this.campanhaStatus[campanhaId];

      this.srcImage = campanhaStatus.bannerSrc;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.bannerHeader {
  min-height: 180px;
  height: auto;
  width: 100%;
  background: var(--brand-secondary, $brand-secondary);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 40px;
  margin-bottom: 15px;
  gap: 20px;

  img {
    height: auto;
    max-height: 140px;
    width: auto;
    object-fit: contain;
    flex-shrink: 0;
  }

  .titleBanner {
    color: #ffffff;
    flex: 1;
    min-width: 0;
    
    span {
      font-weight: bold;
      font-size: 14px;
      display: block;
      margin-bottom: 8px;
    }
    h3 {
      font-size: 28px;
      font-weight: bold;
      line-height: 1.3;
      margin: 0;
      span {
        color: #92e3a9;
        font-size: 28px;
      }
    }
  }

  .titleBanner-ag {
    color: #ffffff;
    flex: 1;
    min-width: 0;
    
    span {
      font-weight: bold;
      font-size: 14px;
      display: block;
      margin-bottom: 8px;
    }
    h3 {
      font-size: 28px;
      font-weight: bold;
      line-height: 1.3;
      margin: 0;
      span {
        color: #f15a22;
        font-size: 28px;
      }
    }
  }
}

@media (max-width: 968px) {
  .bannerHeader {
    padding: 25px 30px;
    min-height: 160px;

    .titleBanner,
    .titleBanner-ag {
      h3 {
        font-size: 24px;
        span {
          font-size: 24px;
        }
      }
    }

    img {
      max-height: 120px;
    }
  }
}

@media (max-width: 728px) {
  .bannerHeader {
    padding: 20px;
    min-height: 140px;
    gap: 15px;

    .titleBanner,
    .titleBanner-ag {
      span {
        font-size: 12px;
        margin-bottom: 6px;
      }
      h3 {
        font-size: 20px;
        span {
          font-size: 20px;
        }
      }
    }

    img {
      max-height: 100px;
    }
  }
}

@media (max-width: 548px) {
  .bannerHeader {
    padding: 16px;
    min-height: auto;
    flex-direction: column;
    text-align: center;
    gap: 12px;

    .titleBanner,
    .titleBanner-ag {
      span {
        font-size: 11px;
        margin-bottom: 6px;
      }
      h3 {
        font-size: 18px;
        span {
          font-size: 18px;
        }
      }
    }

    img {
      max-height: 80px;
      width: auto;
    }
  }
}

@media (max-width: 400px) {
  .bannerHeader {
    padding: 12px;
    gap: 10px;

    .titleBanner,
    .titleBanner-ag {
      span {
        font-size: 10px;
        margin-bottom: 4px;
      }
      h3 {
        font-size: 16px;
        span {
          font-size: 16px;
        }
      }
    }

    img {
      max-height: 70px;
    }
  }
}
</style>
